import { get as idbGet, set as idbSet, del as idbDel } from 'idb-keyval';

// Studio code uses a custom shape: storage.get(key) returns { value } or undefined,
// storage.set(key, value) writes the raw value. Wraps idb-keyval to match.
export const storage = {
  async get(key) {
    const v = await idbGet(key);
    return v === undefined ? undefined : { value: v };
  },
  async set(key, value) {
    await idbSet(key, value);
  },
  async del(key) {
    await idbDel(key);
  },
};

// Expose globally — the legacy monolith reads `window.storage.*` directly.
if (typeof window !== 'undefined') {
  window.storage = storage;
}
